import React, { useState, useEffect, Fragment } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Add, BeenhereRounded } from '@material-ui/icons';

//tabla y card components
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

//servicios
import { wsGet } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { useParams } from 'react-router-dom';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: '500'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 140 },
  { Header: 'Tipo', accessor: 'item_type' },
  { Header: 'Código', accessor: 'item_code' },
  { Header: 'Descripción', accessor: 'item_description' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default function ProviderGroupDetail() {
  const classes = useStyles();
  const { id } = useParams();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones

  const [pgDetails, setPGDetails] = useState({ details: [] });

  async function listProviderGroupDetails() {
    let response = await wsGet('com/provider-group', id);
    if (response.success) setPGDetails(response.data);
  }

  useEffect(() => {
    listProviderGroupDetails();
  }, []);

  return (
    <Fragment>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={listProviderGroupDetails}
          group={pgDetails}
        />
      ) : undefined}

      <Card>
        <CardHeader icon>
          <AllowedGuard
            permission={ConstantPermissions.COM_ZONE_QUOTAS_STORE}
            component={
              <CardIcon color="primary">
                <BeenhereRounded style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <CardIcon onClick={() => setOpen({})} pointer="true" color="success">
              <Add />
            </CardIcon>
          </AllowedGuard>
          <h4 className={classes.cardIconTitle}>
            Detalle de: {`${pgDetails.CardCode} - ${pgDetails.CardName} (${pgDetails.description})`}
          </h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            excelName="grupos_proveedor"
            defaultWidth={1000}
            columns={columns}
            data={pgDetails.details.map((item, i) => {
              let itemType = '';
              switch (item.item_type) {
                case 'L':
                  itemType = 'Línea';
                  break;
                case 'F':
                  itemType = 'Familia';
                  break;
                case 'S':
                  itemType = 'SubFamilia';
                  break;
                case 'P':
                  itemType = 'Producto';
                  break;
                default:
                  itemType = 'X';
              }

              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <AllowedGuard permission={ConstantPermissions.COM_ZONE_QUOTAS_DELETED}>
                      <ButtonDelete
                        entity={`com/provider-group/${id}/detail`}
                        id={item.id}
                        reload={listProviderGroupDetails}
                      />
                    </AllowedGuard>
                  </div>
                ),
                item_type: itemType,
                item_code: item.item_code,
                item_description: item.item_description,
                actions: ''
              };
            })}
          />
        </CardBody>
      </Card>
    </Fragment>
  );
}
